export class Filter {
  public searchString:string;
  public mainCategory:string;
  public subCategory:string;

  public constructor(searchString, mainCategory, subCategory){
    this.searchString = searchString;
    this.mainCategory = mainCategory;
    this.subCategory = subCategory;
  }
}



// WEBPACK FOOTER //
// ./src/app/filter/filter.ts